export enum LocalStorageKeys {
  AccessToken = 'accessToken',
}

export enum FileMimeTypes {
  Scn = '.scn',
  Png = 'image/png',
  Svg = 'image/svg+xml',
  Jpeg = 'image/jpeg',
  Jpg = 'image/jpg',
  Mp4 = 'video/mp4',
  Webm = 'video/webm',
  Mov = 'video/quicktime',
  Csv = 'text/csv',
  Pth = '.pth',
  Gcr = '.gcr',
  Safetensors = '.safetensors',
}

export enum ItemStatusEnum {
  Archived = 'ARCHIVED',
  Ready = 'READY',
  Active = 'ACTIVE',
}

export enum PrinterTypeEnum {
  SDK = 'SDK',
  API = 'API',
}

export const statusOptions = [
  { value: ItemStatusEnum.Ready, id: ItemStatusEnum.Ready },
  { value: ItemStatusEnum.Archived, id: ItemStatusEnum.Archived },
];
